var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
        [
          _c(
            "c-search-box",
            { ref: "searchbox", on: { enter: _vm.getList } },
            [
              _c("template", { slot: "search" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                  },
                  [
                    _c("c-plant", {
                      attrs: { type: "search", name: "plantCd" },
                      model: {
                        value: _vm.searchParam.plantCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "plantCd", $$v)
                        },
                        expression: "searchParam.plantCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                  },
                  [
                    _c("c-dept", {
                      attrs: { type: "search", name: "deptCd" },
                      model: {
                        value: _vm.searchParam.deptCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "deptCd", $$v)
                        },
                        expression: "searchParam.deptCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                  },
                  [
                    _c("c-text", {
                      attrs: { label: "LBLUSER", name: "userName" },
                      model: {
                        value: _vm.searchParam.userName,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "userName", $$v)
                        },
                        expression: "searchParam.userName",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "c-table",
            {
              ref: "userTable",
              attrs: {
                title: "LBL0000780",
                columns: _vm.grid.columns,
                data: _vm.grid.data,
                gridHeight: _vm.grid.height,
                columnSetting: false,
                isFullScreen: false,
                filtering: false,
                selection: "multiple",
                rowKey: "userId",
              },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _c("c-btn", {
                        attrs: { label: "LBLSEARCH", icon: "search" },
                        on: { btnClicked: _vm.getList },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1",
          staticStyle: {
            margin: "auto 0",
            "line-height": "35px",
            "text-align": "center",
          },
        },
        [
          _c("c-btn", {
            attrs: {
              label: "LBLCONFIRM",
              icon: "arrow_forward_ios",
              color: "blue-grey-4",
            },
            on: {
              btnClicked: function ($event) {
                return _vm.addApprLine("AKC0000004")
              },
            },
          }),
          _c("c-btn", {
            attrs: {
              label: "LBL0000781",
              icon: "arrow_forward_ios",
              color: "green-7",
            },
            on: {
              btnClicked: function ($event) {
                return _vm.addApprLine("AKC0000002")
              },
            },
          }),
          _c("c-btn", {
            attrs: {
              label: "LBL0000778",
              icon: "arrow_forward_ios",
              color: "blue-7",
            },
            on: {
              btnClicked: function ($event) {
                return _vm.addApprLine("AKC0000003")
              },
            },
          }),
          _c("c-btn", {
            attrs: {
              label: "LBL0000754",
              icon: "arrow_forward_ios",
              color: "blue-grey-4",
            },
            on: {
              btnClicked: function ($event) {
                return _vm.addApprLine("AKC0000009")
              },
            },
          }),
          _c("br"),
          _c("br"),
          _c("c-btn", {
            attrs: { label: "LBLREMOVE", icon: "arrow_back_ios", color: "red" },
            on: { btnClicked: _vm.delApprLine },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm cardClassDetailFormLine",
              attrs: { title: "LBL0000755", height: "270px" },
            },
            [
              _c(
                "template",
                { slot: "card-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _c("c-btn", {
                        attrs: { label: "LBL0000756", icon: "save" },
                        on: { btnClicked: _vm.select },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-12",
                    staticStyle: { padding: "5px !important" },
                  },
                  [
                    _c(
                      "draggable",
                      _vm._b(
                        {
                          staticClass: "list-group",
                          attrs: {
                            tag: "ul",
                            list: _vm.linegrid.data,
                            handle: ".linehandle",
                            move: _vm.checkMove,
                          },
                          on: {
                            start: function ($event) {
                              _vm.drag = true
                            },
                            end: function ($event) {
                              _vm.drag = false
                            },
                            change: _vm.moveApprLine,
                          },
                        },
                        "draggable",
                        _vm.dragOptions,
                        false
                      ),
                      [
                        _c(
                          "transition-group",
                          {
                            attrs: {
                              type: "transition",
                              name: !_vm.drag ? "flip-list" : null,
                            },
                          },
                          _vm._l(_vm.linegrid.data, function (element, idx) {
                            return _c(
                              "li",
                              {
                                key:
                                  element.approvalUserId +
                                  element.approvalKindCd,
                                staticClass: "list-group-item",
                                class: { linehandle: _vm.validDrag(element) },
                              },
                              [
                                _vm.validDrag(element)
                                  ? _c(
                                      "i",
                                      {
                                        staticClass:
                                          "material-icons linehandley",
                                      },
                                      [_vm._v("reorder")]
                                    )
                                  : _vm._e(),
                                !_vm.validDrag(element)
                                  ? _c(
                                      "i",
                                      {
                                        staticClass:
                                          "material-icons linehandlex no-move",
                                      },
                                      [_vm._v("reorder")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "linetext linespan1",
                                    class: _vm.getLineKindColor(
                                      element.approvalKindCd
                                    ),
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(element.approvalKindName) + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "linetext linespan2" },
                                  [_vm._v(_vm._s(element.deptName) + " ")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "linetext linespan3" },
                                  [
                                    _vm._v(
                                      _vm._s(element.approvalUserName) + " "
                                    ),
                                  ]
                                ),
                                _vm.validDrag(element)
                                  ? _c(
                                      "i",
                                      {
                                        staticClass: "material-icons lineclose",
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeAt(idx)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v("clear"),
                                        _c("q-tooltip", [
                                          _vm._v("결재선 삭제"),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c("br"),
          _c("c-table", {
            ref: "lineTable2",
            attrs: {
              title: "LBL0000754",
              columnSetting: false,
              isFullScreen: false,
              hideBottom: true,
              usePaging: false,
              filtering: false,
              columns: _vm.linegrid2.columns,
              data: _vm.linegrid2.data,
              gridHeight: _vm.linegrid2.height,
              selection: "multiple",
              rowKey: "approvalUserId",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }